import React from 'react'
import Svg from '../../SvgComponent/Svg'
import { SvgProps } from '../../SvgComponent/types'

const RefreshIcon: React.FC<SvgProps> = ({ width, height, color, ...props }) => {
  return (
    <Svg width={width || '16'} height={height || '16'} viewBox="0 0 16 16" fill="none" {...props}>
      <g id="tdesign:refresh">
        <path
          id="Vector"
          d="M13.6668 3.89C13.0181 2.9944 12.1663 2.26546 11.1812 1.76306C10.1961 1.26066 9.10589 0.99915 8.00008 1C4.38208 1 1.40675 3.74334 1.03808 7.264L0.96875 7.92667L2.29542 8.066L2.36408 7.40267C2.48825 6.22921 2.97561 5.12377 3.75817 4.24057C4.54073 3.35738 5.57946 2.74048 6.72944 2.47594C7.87941 2.2114 9.08329 2.31242 10.1731 2.7649C11.2629 3.21738 12.1843 3.99875 12.8088 5H10.3334V6.33334H15.0001V1.66667H13.6668V3.89ZM13.7048 7.934L13.6354 8.59734C13.5111 9.77061 13.0237 10.8758 12.2411 11.7588C11.4586 12.6418 10.42 13.2586 9.27024 13.5231C8.12043 13.7876 6.91673 13.6867 5.82703 13.2344C4.73733 12.7821 3.81595 12.001 3.19142 11H5.66675V9.66667H1.00008V14.3333H2.33342V12.11C2.98203 13.0056 3.83387 13.7345 4.81896 14.2369C5.80405 14.7393 6.89428 15.0009 8.00008 15C11.6174 15 14.5934 12.2567 14.9614 8.736L15.0308 8.07334L13.7048 7.934Z"
          fill={color || '#EDEBF7'}
        />
      </g>
    </Svg>
  )
}

export default RefreshIcon
